export const PDF_HEADER_REF = 'pdfHeaderRef';
export const PDF_CONTENT_REF = 'pdfContentRef';
export const PDF_FOOTER_REF = 'pdfFooterRef';
